// extracted by mini-css-extract-plugin
export default {"badge":"StatusBadge_badge__KVB57","sm":"StatusBadge_sm__v+e80","dot":"StatusBadge_dot__zcQQm"};